/**
 * Duplicate prevention helpers using localStorage
 */

const SIGNUP_KEY = "pixelmaker_signup_events_sent";
const PURCHASE_KEY = "pixelmaker_purchase_events_sent";

function getTrackedSet(key: string): Set<string> {
  try {
    const stored = localStorage.getItem(key);
    return stored ? new Set(JSON.parse(stored)) : new Set();
  } catch {
    return new Set();
  }
}

function addToTrackedSet(key: string, userId: string) {
  try {
    const set = getTrackedSet(key);
    set.add(userId);
    localStorage.setItem(key, JSON.stringify([...set]));
  } catch {
    // Ignore storage errors
  }
}

// Signup tracking
export const hasTrackedSignup = (userId: string) => getTrackedSet(SIGNUP_KEY).has(userId);
export const markSignupTracked = (userId: string) => addToTrackedSet(SIGNUP_KEY, userId);

// Purchase tracking
export const hasTrackedPurchase = (userId: string) => getTrackedSet(PURCHASE_KEY).has(userId);
export const markPurchaseTracked = (userId: string) => addToTrackedSet(PURCHASE_KEY, userId);

export function clearPurchaseTracking(userId?: string) {
  try {
    if (userId) {
      const set = getTrackedSet(PURCHASE_KEY);
      set.delete(userId);
      localStorage.setItem(PURCHASE_KEY, JSON.stringify([...set]));
    } else {
      localStorage.removeItem(PURCHASE_KEY);
    }
  } catch {
    // Ignore storage errors
  }
}

/** Check if user signed up within threshold (10 minutes) */
export function isRecentSignup(createdAt?: string): boolean {
  if (!createdAt) return false;
  const threshold = 10 * 60 * 1000;
  return Date.now() - new Date(createdAt).getTime() < threshold;
}
